export { useScrollToHash } from './use-scroll-to-hash';
